export default __webpack_public_path__ + "static/media/signup-mobile-0.74c8506e.png";